$(document).ready(function () {

    var container = document.getElementById("boxes-bubbles-container");
    if (!container || typeof Konva === 'undefined' || typeof jobsBubbles === 'undefined') {
        return;
    }

    var section = container.closest('.boxes-bubbles');
    var groups = (typeof bubbleGroups !== 'undefined') ? bubbleGroups : [];
    var fontFamily = getComputedStyle(container).fontFamily || 'Arial';

    var speedMultiplier = 0.07; // controls the speed of the free-floating bubbles
    var mode = 'problema';      // 'problema' = free animation, 'solutie' = grid by category
    var draggedBubble = null;   // bubble currently being dragged (used by the "Solutie" push)

    // Description panel (bubbles-v2 only): clicking a bubble that has a text for the current state shows
    // it at the top of the canvas. The bubbles retreat below it: in "Problema" the band is a
    // no-go zone they are pushed out of, in "Solutie" the grid slides down. The canvas grows by
    // the band's height while it is shown.
    var descEl = section ? section.querySelector('.boxes-bubbles__description') : null;
    var DESC_TOP = 20;          // px between the top of the canvas and the text
    var DESC_GAP = 24;          // px between the text and the first bubbles
    var ACTIVE_SCALE = 1.08;    // radius multiplier of the selected bubble
    var ACTIVE_RING = 0.65;     // the selected bubble's gradient ring starts here (thicker ring)
    var zone = 0;               // current height of the band reserved at the top of the canvas
    var zoneTarget = 0;         // height the band eases towards
    var activeBubble = null;    // bubble whose description is shown
    var descClearTimer = null;

    var width = container.offsetWidth;
    var height = container.offsetHeight;
    var baseHeight = height; // canvas height used by the "Problema" state (driven by CSS)
    var modeHeight = height; // canvas height of the current state, without the description band

    var stage = new Konva.Stage({
        container: 'boxes-bubbles-container',
        width: width,
        height: height
    });

    var labelLayer = new Konva.Layer({ listening: false }); // category headings (behind bubbles)
    var layer = new Konva.Layer();
    stage.add(labelLayer);
    stage.add(layer);
    labelLayer.hide();

    if (descEl) {
        container.appendChild(descEl); // overlay the top of the canvas
    }

    // ----- helpers -------------------------------------------------------

    var GRID_PADDING_X = 50; // left/right padding of the "Solutie" grid
    var RING_INNER = 0.8;    // the gradient ring starts at this fraction of the radius
    var TEXT_GAP = 5;        // px of clear space between the text box and the gradient ring

    // Inset the text so its box stops TEXT_GAP px before the gradient ring (measured where the
    // ring is widest). Applied in both states. Returns the inner width/height for the text.
    function applyTextInset(bubble) {
        var pad = Math.max(0, Math.round(bubble.radius * (1 - RING_INNER) + TEXT_GAP));
        bubble.content.style.padding = pad + 'px';
        return bubble.radius * 2 - pad * 2;
    }

    function gridRadius() {
        var w = $(window).width();
        if (w > 1100) return 79;
        if (w > 767) return 63;
        return 46;
    }

    function setContentProblema(bubble) {
        bubble.content.innerHTML = '<div class="text">' + bubble.title + '</div>';
    }

    function setContentSolutie(bubble) {
        // The order number comes from the title the user typed (e.g. "1. Foo"), not from an
        // auto-generated index. Split the leading number onto its own line above the title.
        var match = ('' + bubble.title).match(/^\s*(\d+[\.\)]?)\s*([\s\S]*)$/);
        var nr = match ? match[1] : '';
        var rest = match ? match[2] : bubble.title;

        bubble.content.innerHTML =
            '<div class="text">' +
                (nr ? '<span class="bubble-nr">' + nr + '</span>' : '') +
                '<span class="bubble-title">' + rest + '</span>' +
            '</div>';
    }

    function freeRadiusFor(data) {
        var r = data.radius_small;
        if ($(window).width() > 767) r = data.radius_medium;
        if ($(window).width() > 1100) r = data.radius_large;
        if (1 * r < 1) r = data.radius_small;
        if (1 * r < 1) r = gridRadius(); // fallback when no radius is configured
        return 1 * r;
    }

    function themeColor() {
        return container.getAttribute('data-bs-theme') === 'dark' ? '#000' : '#fff';
    }

    function ringStops(bubble) {
        var bg = themeColor();
        var start = bubble === activeBubble ? ACTIVE_RING : RING_INNER;
        return [0, bg, start, bg, 1, bubble.color];
    }

    function baseRadius(bubble) {
        return mode === 'solutie' ? gridRadius() : bubble.freeRadius;
    }

    function radiusFor(bubble) {
        return baseRadius(bubble) * (bubble === activeBubble ? ACTIVE_SCALE : 1);
    }

    // Re-apply size, ring and glow after the bubble became (or stopped being) the selected one.
    function refreshBubble(bubble) {
        applyRadius(bubble, radiusFor(bubble));
        var circle = bubble.group.findOne('Circle');
        if (circle) {
            circle.fillRadialGradientColorStops(ringStops(bubble));
            circle.shadowEnabled(bubble === activeBubble);
        }
        fitBubbleText(bubble, applyTextInset(bubble));
    }

    function labelColor() {
        return container.getAttribute('data-bs-theme') === 'dark' ? '#ffffff' : '#0b1f3a';
    }

    function updateHTMLPosition(bubble) {
        bubble.content.style.left = bubble.x + 'px';
        bubble.content.style.top = bubble.y + 'px';
    }

    function applyRadius(bubble, r) {
        bubble.radius = r;
        var circle = bubble.group.findOne('Circle');
        if (circle) {
            circle.radius(r);
            circle.fillRadialGradientEndRadius(r);
        }
        bubble.content.style.width = (r * 2) + 'px';
        bubble.content.style.height = (r * 2) + 'px';
    }

    // ----- build bubbles -------------------------------------------------

    var bubbles = jobsBubbles.map(function (data) {
        var fr = freeRadiusFor(data);
        var x = fr + Math.random() * (width - 2 * fr);
        var y = fr + Math.random() * (height - 2 * fr);
        return Object.assign({}, data, { freeRadius: fr, x: x, y: y, radius: fr });
    });

    function createBubble(bubble) {
        var group = new Konva.Group({
            x: bubble.x,
            y: bubble.y,
            draggable: true
        });

        var circle = new Konva.Circle({
            radius: bubble.radius,
            fillRadialGradientStartPoint: { x: 0, y: 0 },
            fillRadialGradientStartRadius: 0,
            fillRadialGradientEndPoint: { x: 0, y: 0 },
            fillRadialGradientEndRadius: bubble.radius,
            fillRadialGradientColorStops: ringStops(bubble),
            shadowColor: bubble.color,   // glow of the selected bubble
            shadowBlur: 30,
            shadowOpacity: 0.9,
            shadowEnabled: false
        });

        var content = document.createElement('div');
        content.className = 'bubble-content';
        content.innerHTML = '<div class="text">' + bubble.title + '</div>';
        content.style.width = (bubble.radius * 2) + 'px';
        content.style.height = (bubble.radius * 2) + 'px';
        content.style.left = bubble.x + 'px';
        content.style.top = bubble.y + 'px';
        content.style.transform = 'translate(-50%, -50%)';
        container.appendChild(content);
        bubble.content = content;
        fitBubbleText(bubble, applyTextInset(bubble));

        group.add(circle);

        group.on('mousedown touchstart', function () {
            bubble.moved = false; // a new press; Konva fires no click after a drag
        });

        group.on('dragstart', function () {
            bubble.isDragging = true;
            bubble.moved = false;
            draggedBubble = bubble;
        });

        group.on('dragend', function () {
            bubble.isDragging = false;
            draggedBubble = null;

            bubble.x = group.x();
            bubble.y = group.y();
            updateHTMLPosition(bubble);
            // In "Solutie" the animation loop eases this bubble (and the ones it pushed)
            // back to their slots.
        });

        group.on('dragmove', function () {
            bubble.moved = true;

            if (mode === 'solutie') {
                // free drag; the bubble springs back to its slot on release
                bubble.x = group.x();
                bubble.y = group.y();
                updateHTMLPosition(bubble);
                return;
            }

            // "Problema": keep the bubble inside the canvas and push neighbours away
            var newX = group.x();
            var newY = group.y();

            if (newX - bubble.radius < 0) newX = bubble.radius;
            if (newX + bubble.radius > width) newX = width - bubble.radius;
            if (newY - bubble.radius < zone) newY = zone + bubble.radius;
            if (newY + bubble.radius > height) newY = height - bubble.radius;

            bubble.x = newX;
            bubble.y = newY;
            updateHTMLPosition(bubble);

            group.x(newX);
            group.y(newY);

            bubbles.forEach(function (otherBubble) {
                if (otherBubble === bubble) return;

                var dx = otherBubble.x - bubble.x;
                var dy = otherBubble.y - bubble.y;
                var distance = Math.sqrt(dx * dx + dy * dy);

                if (distance < bubble.radius + otherBubble.radius) {
                    var angle = Math.atan2(dy, dx);
                    var overlap = bubble.radius + otherBubble.radius - distance;
                    var newOtherX = otherBubble.x + overlap * Math.cos(angle);
                    var newOtherY = otherBubble.y + overlap * Math.sin(angle);

                    if (newOtherX - otherBubble.radius < 0) newOtherX = otherBubble.radius;
                    if (newOtherX + otherBubble.radius > width) newOtherX = width - otherBubble.radius;
                    if (newOtherY - otherBubble.radius < 0) newOtherY = otherBubble.radius;
                    if (newOtherY + otherBubble.radius > height) newOtherY = height - otherBubble.radius;

                    otherBubble.x = newOtherX;
                    otherBubble.y = newOtherY;
                    updateHTMLPosition(otherBubble);

                    otherBubble.group.x(newOtherX);
                    otherBubble.group.y(newOtherY);
                }
            });
        });

        group.on('mouseover', function () { document.body.style.cursor = 'pointer'; });
        group.on('mouseout', function () { document.body.style.cursor = 'default'; });

        group.on(descEl ? 'click tap' : 'click', function () {
            if (bubble.moved) return; // a drag, not a click

            // a touch can be reported as both "tap" and "click": handle it once
            var now = Date.now();
            if (now - (bubble.lastPress || 0) < 400) return;
            bubble.lastPress = now;

            if (descEl && descriptionFor(bubble)) {
                if (activeBubble === bubble) {
                    hideDescription();
                } else {
                    showDescription(bubble);
                }
                return;
            }

            if (bubble.url != '') {
                window.location = bubble.url;
                return;
            }

            if (descEl) hideDescription();
        });

        return group;
    }

    // Make the "Problema" canvas tall enough for the bubbles to fit without crowding.
    function problemaHeight() {
        container.style.height = '';      // read the CSS-driven height first
        var cssH = container.offsetHeight;

        var area = 0, maxR = 0;
        bubbles.forEach(function (b) {
            var r = b.freeRadius;
            area += Math.PI * r * r;
            if (r > maxR) maxR = r;
        });

        var needed = area / (0.5 * width); // spread the bubble area over ~50% of the canvas
        needed = Math.max(needed, 2 * maxR + 40);
        return Math.max(cssH, Math.ceil(needed));
    }

    // Size the canvas to the bubbles and spread them across it.
    height = problemaHeight();
    baseHeight = height;
    modeHeight = height;
    container.style.height = height + 'px';
    stage.height(height);

    bubbles.forEach(function (b) {
        b.x = b.radius + Math.random() * (width - 2 * b.radius);
        b.y = b.radius + Math.random() * (height - 2 * b.radius);
    });

    bubbles.forEach(function (bubble) {
        bubble.group = createBubble(bubble);
        layer.add(bubble.group);
    });

    layer.draw();
    updateRadialColor(container.getAttribute('data-bs-theme'));

    // ----- description panel ---------------------------------------------

    // Each state has its own text: "Problema" = title_2, "Solutie" = short_description.
    function descriptionFor(bubble) {
        return (mode === 'solutie' ? bubble.description_solutie : bubble.description_problema) || '';
    }

    function measureZone() {
        if (!descEl || !activeBubble) return 0;
        return DESC_TOP + descEl.offsetHeight + DESC_GAP;
    }

    function showDescription(bubble) {
        clearTimeout(descClearTimer);

        var previous = activeBubble;
        activeBubble = bubble;
        if (previous) refreshBubble(previous);
        refreshBubble(bubble);

        var wasEmpty = descEl.innerHTML === '';
        descEl.innerHTML = descriptionFor(bubble);
        if (wasEmpty) void descEl.offsetHeight; // leave display:none first, so the fade-in runs
        descEl.classList.add('is-visible');
        zoneTarget = measureZone();

        layer.batchDraw();
    }

    // immediate: drop the band at once (state switch) instead of easing the bubbles back
    function hideDescription(immediate) {
        if (!descEl) return;
        clearTimeout(descClearTimer);

        var previous = activeBubble;
        activeBubble = null;
        if (previous) refreshBubble(previous);

        descEl.classList.remove('is-visible');
        zoneTarget = 0;

        if (immediate) {
            setZone(0); // the caller sets the new state's height right after
            descEl.innerHTML = '';
        } else {
            descClearTimer = setTimeout(function () {
                if (!activeBubble) descEl.innerHTML = ''; // after the fade-out
            }, 300);
        }

        layer.batchDraw();
    }

    // Set the band height: the canvas grows by it, and the "Solutie" category headings and
    // separators slide down with the grid.
    function setZone(value) {
        zone = value;
        height = modeHeight + zone;
        container.style.height = height + 'px';
        stage.height(height);
        labelLayer.y(zone);
        labelLayer.batchDraw();
    }

    // Ease the band (and with it the canvas height) towards its target.
    function stepZone() {
        if (zone === zoneTarget) return;

        var next = zone + (zoneTarget - zone) * 0.15;
        if (Math.abs(zoneTarget - next) < 0.5) next = zoneTarget;
        setZone(next);
    }

    // ----- "Solutie" grid layout ----------------------------------------

    function layoutGrid() {
        var radius = gridRadius();
        var gapX = Math.round(radius * 0.9);
        var rowGap = Math.round(radius * 0.45); // vertical space between rows of the same category
        var sepMargin = 60;                     // space between bubbles and the category separator line
        var labelGap = 32;
        var isMobile = $(window).width() <= 767;
        var paddingX = isMobile ? 0 : GRID_PADDING_X; // no side padding on mobile
        var labelX = isMobile ? 20 : GRID_PADDING_X;  // category label keeps a small left padding on mobile
        var availWidth = Math.max(radius * 2, width - paddingX * 2);
        var y = 30;
        var first = true;

        labelLayer.destroyChildren();

        groups.forEach(function (group) {
            if (!group.items.length) return;

            // 1px separator line between categories
            if (!first) {
                y += sepMargin;
                labelLayer.add(new Konva.Line({
                    points: [paddingX, y, width - paddingX, y],
                    stroke: '#EBEFF2',
                    strokeWidth: 1
                }));
                y += sepMargin;
            }
            first = false;

            if (group.label) {
                labelLayer.add(new Konva.Text({
                    x: labelX,
                    y: y,
                    text: ('' + group.label).toUpperCase(),
                    fontFamily: fontFamily,
                    fontSize: 14,
                    fontStyle: 'bold',
                    letterSpacing: 2,
                    fill: labelColor()
                }));
                y += labelGap;
            }

            var perRow = Math.max(1, Math.floor((availWidth + gapX) / (radius * 2 + gapX)));
            var rowCount = Math.ceil(group.items.length / perRow);

            for (var r = 0; r < rowCount; r++) {
                var rowItems = group.items.slice(r * perRow, (r + 1) * perRow);
                var rowWidth = rowItems.length * (radius * 2) + (rowItems.length - 1) * gapX;
                var startX = (width - rowWidth) / 2 + radius;

                for (var c = 0; c < rowItems.length; c++) {
                    var bubble = bubbles[rowItems[c]];
                    bubble.slotX = startX + c * (radius * 2 + gapX);
                    bubble.slotY = y + radius;
                }

                y += radius * 2;
                if (r < rowCount - 1) y += rowGap; // gap only between rows, not after the last
            }
        });

        return y + 30; // total content height
    }

    // Ease every non-dragged bubble toward its slot. While a bubble is dragged it pushes the
    // bubbles it overlaps off their slots; they spring back once the drag moves away or ends.
    function easeSolutieBubbles() {
        var moved = false;

        bubbles.forEach(function (b) {
            if (b.slotX == null || b === draggedBubble || b.isDragging) return;

            var slotY = b.slotY + zone; // the grid slides down below the description
            var tx = b.slotX;
            var ty = slotY;

            if (draggedBubble) {
                var dx = b.slotX - draggedBubble.x;
                var dy = slotY - draggedBubble.y;
                var dist = Math.sqrt(dx * dx + dy * dy);
                var minDist = draggedBubble.radius + b.radius + 6;

                if (dist === 0) {
                    tx = b.slotX + minDist;
                } else if (dist < minDist) {
                    var push = minDist - dist;
                    tx = b.slotX + (dx / dist) * push;
                    ty = slotY + (dy / dist) * push;
                }
            }

            var nx = b.x + (tx - b.x) * 0.2;
            var ny = b.y + (ty - b.y) * 0.2;

            if (Math.abs(nx - b.x) > 0.1 || Math.abs(ny - b.y) > 0.1) {
                b.x = nx;
                b.y = ny;
                b.group.position({ x: nx, y: ny });
                updateHTMLPosition(b);
                moved = true;
            }
        });

        if (moved) layer.batchDraw();
    }

    // Shrink the font until the text fits the inner box. Wrapping (break-word) handles width,
    // so we only need to shrink when it overflows vertically (i.e. needs more than two lines).
    function fitBubbleText(bubble, available) {
        var textEl = bubble.content.querySelector('.text');
        if (!textEl) return;
        textEl.style.fontSize = ''; // reset to the CSS base size
        var size = parseFloat(getComputedStyle(textEl).fontSize) || 15;
        var min = 9;
        while (size > min && textEl.scrollHeight > available) {
            size -= 1;
            textEl.style.fontSize = size + 'px';
        }
    }

    function enterSolutie() {
        hideDescription(true);
        mode = 'solutie';

        var radius = gridRadius();
        bubbles.forEach(function (b) { applyRadius(b, radius); });

        var totalHeight = layoutGrid();
        modeHeight = Math.max(baseHeight, totalHeight);
        height = modeHeight;
        container.style.height = height + 'px';
        stage.height(height);

        bubbles.forEach(function (b) {
            setContentSolutie(b);
            fitBubbleText(b, applyTextInset(b));
            b.x = b.slotX;
            b.y = b.slotY;
            b.group.position({ x: b.slotX, y: b.slotY });
            updateHTMLPosition(b);
        });

        labelLayer.show();
        labelLayer.draw();
        layer.draw();
    }

    function enterProblema() {
        hideDescription(true);
        mode = 'problema';

        labelLayer.destroyChildren(); // drop category labels + separators so none linger on mobile
        labelLayer.hide();
        labelLayer.draw();

        bubbles.forEach(function (b) { applyRadius(b, b.freeRadius); });

        height = problemaHeight(); // tall enough for the bubbles to fit
        baseHeight = height;
        modeHeight = height;
        container.style.height = height + 'px';
        stage.height(height);

        bubbles.forEach(function (b) {
            setContentProblema(b);
            fitBubbleText(b, applyTextInset(b)); // shrink long titles to fit the bubble

            // Spread the bubbles out again (instead of reusing the clustered grid slots,
            // which otherwise pile up in a corner and overlap).
            b.x = b.radius + Math.random() * (width - 2 * b.radius);
            b.y = b.radius + Math.random() * (height - 2 * b.radius);
            b.group.position({ x: b.x, y: b.y });
            updateHTMLPosition(b);
        });

        layer.draw();
    }

    // ----- toggle wiring -------------------------------------------------

    if (section) {
        section.querySelectorAll('.boxes-bubbles__toggle-button').forEach(function (button) {
            button.addEventListener('click', function () {
                section.querySelectorAll('.boxes-bubbles__toggle-button').forEach(function (item) {
                    item.classList.remove('active');
                    item.setAttribute('aria-selected', 'false');
                });
                button.classList.add('active');
                button.setAttribute('aria-selected', 'true');

                if (button.getAttribute('data-panel') === 'solutie') {
                    enterSolutie();
                } else {
                    enterProblema();
                }
            });
        });
    }

    // ----- free-floating animation loop ("Problema") ---------------------

    function detectCollisions() {
        for (var i = 0; i < bubbles.length; i++) {
            for (var j = i + 1; j < bubbles.length; j++) {
                var bubble1 = bubbles[i];
                var bubble2 = bubbles[j];

                var dx = bubble2.x - bubble1.x;
                var dy = bubble2.y - bubble1.y;
                var distance = Math.sqrt(dx * dx + dy * dy);

                if (distance < bubble1.radius + bubble2.radius) {
                    var angle = Math.atan2(dy, dx);
                    var speed1 = Math.sqrt(bubble1.dx * bubble1.dx + bubble1.dy * bubble1.dy);
                    var speed2 = Math.sqrt(bubble2.dx * bubble2.dx + bubble2.dy * bubble2.dy);
                    var direction1 = Math.atan2(bubble1.dy, bubble1.dx);
                    var direction2 = Math.atan2(bubble2.dy, bubble2.dx);

                    bubble1.dx = speed2 * Math.cos(direction2 - angle);
                    bubble1.dy = speed2 * Math.sin(direction2 - angle);
                    bubble2.dx = speed1 * Math.cos(direction1 - angle);
                    bubble2.dy = speed1 * Math.sin(direction1 - angle);

                    var overlap = 0.5 * (distance - bubble1.radius - bubble2.radius);
                    bubble1.x -= overlap * (bubble1.x - bubble2.x) / distance;
                    bubble1.y -= overlap * (bubble1.y - bubble2.y) / distance;
                    bubble2.x += overlap * (bubble1.x - bubble2.x) / distance;
                    bubble2.y += overlap * (bubble1.y - bubble2.y) / distance;

                    if (bubble1.x - bubble1.radius < 0) bubble1.x = bubble1.radius;
                    if (bubble1.x + bubble1.radius > width) bubble1.x = width - bubble1.radius;
                    if (bubble1.y - bubble1.radius < 0) bubble1.y = bubble1.radius;
                    if (bubble1.y + bubble1.radius > height) bubble1.y = height - bubble1.radius;

                    if (bubble2.x - bubble2.radius < 0) bubble2.x = bubble2.radius;
                    if (bubble2.x + bubble2.radius > width) bubble2.x = width - bubble2.radius;
                    if (bubble2.y - bubble2.radius < 0) bubble2.y = bubble2.radius;
                    if (bubble2.y + bubble2.radius > height) bubble2.y = height - bubble2.radius;

                    bubble1.group.x(bubble1.x);
                    bubble1.group.y(bubble1.y);
                    bubble2.group.x(bubble2.x);
                    bubble2.group.y(bubble2.y);
                    updateHTMLPosition(bubble1);
                    updateHTMLPosition(bubble2);
                }
            }
        }
    }

    function update() {
        stepZone();

        if (mode === 'problema') {
            bubbles.forEach(function (bubble) {
                if (!bubble.isDragging) {
                    bubble.x += bubble.dx * speedMultiplier;
                    bubble.y += bubble.dy * speedMultiplier;

                    if (bubble.x - bubble.radius < 0 || bubble.x + bubble.radius > width) bubble.dx = -bubble.dx;

                    if (descEl) {
                        // Bounce by direction, so a bubble left outside the bounds (the band
                        // grew, or the canvas shrank back) heads inside instead of flip-flopping.
                        if (bubble.y - bubble.radius < zone) {
                            bubble.dy = Math.abs(bubble.dy);
                            // ease it out of the description band
                            bubble.y += (zone + bubble.radius - bubble.y) * 0.2;
                        }
                        if (bubble.y + bubble.radius > height) {
                            bubble.dy = -Math.abs(bubble.dy);
                            bubble.y = Math.max(zone + bubble.radius, height - bubble.radius);
                        }
                    } else if (bubble.y - bubble.radius < 0 || bubble.y + bubble.radius > height) {
                        bubble.dy = -bubble.dy;
                    }

                    bubble.group.x(bubble.x);
                    bubble.group.y(bubble.y);
                    updateHTMLPosition(bubble);
                }
            });

            detectCollisions();
            layer.batchDraw();
        } else if (mode === 'solutie') {
            easeSolutieBubbles();
        }

        requestAnimationFrame(update);
    }

    update();

    // ----- theme + resize ------------------------------------------------

    function updateRadialColor(theme) {
        var radialColor = theme === 'dark' ? '#000' : '#fff';

        bubbles.forEach(function (bubble) {
            var circle = bubble.group.findOne('Circle');
            if (circle) {
                circle.fillRadialGradientColorStops(ringStops(bubble));
            }
        });

        layer.batchDraw();
    }

    window.addEventListener('resize', function () {
        var newWidth = container.offsetWidth;

        if (mode === 'solutie') {
            width = newWidth;
            stage.width(newWidth);

            bubbles.forEach(function (b) { applyRadius(b, radiusFor(b)); });

            var totalHeight = layoutGrid();
            modeHeight = Math.max(baseHeight, totalHeight);
            zoneTarget = measureZone(); // the text may have re-wrapped
            setZone(zoneTarget);

            bubbles.forEach(function (b) {
                fitBubbleText(b, applyTextInset(b)); // radius changed → re-inset + re-fit text
                b.x = b.slotX;
                b.y = b.slotY + zone;
                b.group.position({ x: b.x, y: b.y });
                updateHTMLPosition(b);
            });

            labelLayer.batchDraw();
            layer.batchDraw();
            return;
        }

        var oldWidth = width;
        var oldHeight = height;
        width = newWidth;
        var newModeHeight = problemaHeight(); // recompute the fit-height for the new width
        zoneTarget = measureZone();           // the text may have re-wrapped
        zone = zoneTarget;
        var newHeight = newModeHeight + zone;

        var scaleX = newWidth / oldWidth;
        var scaleY = newHeight / oldHeight;
        stage.width(newWidth);
        container.style.height = newHeight + 'px';
        stage.height(newHeight);

        bubbles.forEach(function (bubble) {
            bubble.x *= scaleX;
            bubble.y *= scaleY;
            bubble.group.x(bubble.x);
            bubble.group.y(bubble.y);
            updateHTMLPosition(bubble);
        });

        height = newHeight;
        baseHeight = newModeHeight;
        modeHeight = newModeHeight;

        layer.batchDraw();
    });

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme') {
                var newTheme = container.getAttribute('data-bs-theme');
                updateRadialColor(newTheme);

                labelLayer.getChildren().forEach(function (text) { text.fill(labelColor()); });
                labelLayer.batchDraw();
            }
        });
    });

    observer.observe(container, { attributes: true });

});



// WEBPACK FOOTER //
// ./resources/js/modules/bubbles.js